export default "__VITE_ASSET__mQ$u0VkM__"